import React, { useState, useEffect } from 'react';
import { Main } from './styles';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Slider from '../../components/Slider';
import Chart from '../../components/Chart';
import ContactForm from '../../components/ContactForm';

import noticiasJSON from '../../assets/noticias.json';

interface Noticia {
  Foto: string;
  Título: string;
  Texto: string;
  'Data de publica\u00E7\u00E3o': string;
  editoria?: string;
}

interface Editoria {
  nome: string;
  quantidade: number;
}

const Home: React.FC = () => {
  const [noticias, setNoticias] = useState<Noticia[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [sorter, setSorter] = useState<string>('Data');
  const [filter, setFilter] = useState<string>('Nenhum filtro');
  const [editorias, setEditorias] = useState<Editoria[]>([]);

  useEffect(() => {
    const fakeEditorias = [
      { nome: 'governo', quantidade: 75 },
      { nome: 'carnaval', quantidade: 50 },
      { nome: 'esporte', quantidade: 45 },
      { nome: 'ferias', quantidade: 30 },
      { nome: 'outros', quantidade: 25 },
    ];

    setEditorias(fakeEditorias);
  }, []);

  useEffect(() => {
    const [{ Editorias }] = [...noticiasJSON];

    setCategories(
      Editorias.map(editoria => {
        return editoria.Editoria;
      }),
    );
  }, []);

  useEffect(() => {
    setNoticias([]);
    if (filter !== 'Nenhum filtro') {
      const [filteredEditoria] = noticiasJSON[0].Editorias.filter(
        editoria => editoria.Editoria === filter,
      );

      const mappedNoticias = filteredEditoria.Notícias.map(noticia => {
        return { ...noticia, editoria: filteredEditoria.Editoria };
      });

      let sortedNoticias = mappedNoticias;

      if (sorter === 'Título') {
        sortedNoticias = mappedNoticias.sort((a, b) =>
          a.Título.localeCompare(b.Título),
        );
      } else if (sorter === 'Data') {
        sortedNoticias = mappedNoticias
          .sort((a, b) => {
            const dateA = new Date(
              a['Data de publicação'].split('-').reverse().join('-'),
            );

            const dateB = new Date(
              b['Data de publicação'].split('-').reverse().join('-'),
            );

            return +dateA - +dateB;
          })
          .reverse();
      }

      setNoticias(sortedNoticias);
    } else {
      const mappedEditorias = [...noticiasJSON[0].Editorias];
      let arrNoticias: Noticia[] = [];

      mappedEditorias.forEach(singleEditoria => {
        arrNoticias = [
          ...arrNoticias,
          ...singleEditoria.Notícias.map(noticia => {
            return {
              ...noticia,
              editoria: singleEditoria.Editoria,
            };
          }),
        ];
      });

      let sortedNoticias = arrNoticias;

      if (sorter === 'Título') {
        sortedNoticias = arrNoticias.sort((a, b) =>
          a.Título.localeCompare(b.Título),
        );
      } else if (sorter === 'Data') {
        sortedNoticias = arrNoticias
          .sort((a, b) => {
            const dateA = new Date(
              a['Data de publicação'].split('-').reverse().join('-'),
            );

            const dateB = new Date(
              b['Data de publicação'].split('-').reverse().join('-'),
            );

            return +dateA - +dateB;
          })
          .reverse();
      }

      setNoticias(sortedNoticias);
    }
  }, [filter, sorter]);

  const handleFilter = (value: string) => {
    setFilter(value);
  };

  const handleSorting = (value: string) => {
    setSorter(value);
  };

  return (
    <>
      <Header />
      <Main>
        <Slider />
        <section id="editorias">
          <header>
            <h1>Editorias</h1>
            <div className="selects">
              <div className="select-wrapper">
                <p>Ordenar por:</p>
                <select onChange={e => handleSorting(e.target.value)}>
                  <option>Data</option>
                  <option>Título</option>
                </select>
              </div>
              <div className="select-wrapper">
                <p>Filtar por:</p>
                <select onChange={e => handleFilter(e.target.value)}>
                  <option>Nenhum filtro</option>
                  {categories.map(categoria => {
                    return <option>{categoria}</option>;
                  })}
                </select>
              </div>
            </div>
          </header>

          <ul className="editorias">
            {noticias.map(noticia => {
              return (
                <li className="editoria">
                  <div className="meta">
                    <p>{noticia['Data de publicação'].replaceAll('-', '/')}</p>
                    <p>{noticia.editoria}</p>
                  </div>
                  <img src={`/news/${noticia.Foto}`} alt="Placeholder" />
                  <h1>{noticia.Título}</h1>
                  <p>{noticia.Texto}</p>

                  <a href="http://example.com">Saiba mais</a>
                </li>
              );
            })}
          </ul>
        </section>
        <hr />
        <section id="editorias-mais-acessadas">
          <header>
            <h1>Editorias mais acessadas</h1>
          </header>
          <div>
            <Chart editorias={editorias} />
            <div className="mais-acessadas__texto">
              <h1>Título aqui</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo.
              </p>
            </div>
          </div>
        </section>
        <hr />
        <section>
          <iframe
            title="Minuto News"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2577.7921132900447!2d-0.15814783309122915!3d51.521127174621085!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x79ac8c8b4ce3a65d!2sNando&#39;s%20Baker%20Street!5e0!3m2!1sen!2sbr!4v1606253013148!5m2!1sen!2sbr"
          />
        </section>
        <section id="contato">
          <div className="frame--info">
            <div className="wrapper">
              <header>
                <h1>Entre em contato</h1>
              </header>

              <h2>Onde nos achar</h2>
              <div className="endereco">
                <p>Rua dos Alfeneiros, número 4</p>
                <p>00-91102</p>
                <p>Little Whitning</p>
                <p>Londres/Inglatera</p>
              </div>

              <div className="telefones">
                <p>(21) 4004 - 1234</p>
                <p>(21) 4004 - 4321</p>
              </div>

              <a href="mailto:contato@minutonews.com.br">
                contato@minutonews.com.br
              </a>

              <p>Aberto de segunda a sexta das 09h as 19h</p>
            </div>
          </div>

          <div className="frame--form">
            <ContactForm />
          </div>
        </section>
      </Main>
      <Footer />
    </>
  );
};

export default Home;
